import WalnutPage from './WalnutPage'
export default WalnutPage
